
import { useProfile } from "@/hooks/useProfile";
import { useSession } from "@/hooks/useSession";

export function useTrainingSession() {
  const { session } = useSession();
  const { data: profile } = useProfile(session?.user?.id);
  
  // Make sure we're correctly determining admin status
  const isTrainee = profile?.role === 'trainee';
  const isAdmin = profile?.role === 'admin';
  
  // For debugging
  console.log("useTrainingSession - profile:", profile);
  console.log("useTrainingSession - isAdmin:", isAdmin);
  console.log("useTrainingSession - role:", profile?.role);
  
  return {
    session,
    profile,
    isTrainee,
    isAdmin
  };
}
